import React from 'react';
import {
  ContactUsSection,
  ContactGrid,
  ContactInfoLeft,
  ContactUsContainer,
  ContactDetailRow,
  StaffCard,
  StaffLinks,
} from './Contact.styles';
import {
  FaMapMarkerAlt,
  FaClock,
  FaEnvelope,
  FaPhoneAlt,
} from 'react-icons/fa';

const ContactSection = () => {
  const staff = [
    {
      name: 'Jim Benoit',
      email: 'jbenoit.yoda@outlook.com',
      phone: '902-478-1972',
      role: ' President/CEO ASA/CSO/Auditor/Trainer/Site Inspector/Health & Safety Program and Course Development',
    },
    {
      name: 'Helen Benoit',
      role: 'Office Admin, CSO/IAC/CDA',
      phone: '902-802-9716',
      email: 'hbenoit.yoda@outlook.com',
    },
  ];
  return (
    <ContactUsSection>
      <ContactGrid>
        <ContactInfoLeft>
          <p className="eyebrowHeader">Get In Touch</p>

          <h2>Contact Our Team</h2>

          <p className="contactIntro">
            Have questions about safety training, audits, manuals, or workplace
            compliance support? Reach out and we’ll help point you in the right
            direction.
          </p>

          <ContactDetailRow>
            <FaMapMarkerAlt />
            <div>
              <strong>Address</strong>
              <address>825 Ostrea Lake Rd, Ostrea Lake NS</address>
            </div>
          </ContactDetailRow>

          <ContactDetailRow>
            <FaClock />
            <div>
              <strong>Hours</strong>
              <p>Monday - Friday: 9:00am - 5:00pm</p>
              <p>Saturday & Sunday: Closed</p>
            </div>
          </ContactDetailRow>
        </ContactInfoLeft>

        <ContactUsContainer>
          <h3>Direct Contacts</h3>

          {staff.map((person) => (
            <StaffCard key={person.email}>
              <div>
                <h4>{person.name}</h4>
                <p>{person.role}</p>
              </div>
              <StaffLinks>
                <a href={`mailto:${person.email.toLowerCase()}`}>
                  <FaEnvelope />
                  {person.email.toLowerCase()}
                </a>

                <a href={`tel:${person.phone}`}>
                  <FaPhoneAlt />
                  {person.phone}
                </a>
              </StaffLinks>
            </StaffCard>
          ))}
        </ContactUsContainer>
      </ContactGrid>
    </ContactUsSection>
  );
};

export default ContactSection;
